/* src/app/shared/components/entity-dropdown-multiselect-picker/entity-dropdown-multiselect-picker.component.css */
:host {
  display: block;
  min-width: 0;
}
:host ::ng-deep .p-iftalabel {
  width: 100%;
}
:host ::ng-deep .p-multiselect {
  width: 100%;
  min-width: 0;
}
:host ::ng-deep .p-multiselect-panel {
  min-width: 100%;
}
:host ::ng-deep .p-inputgroup {
  width: 100%;
  align-items: stretch;
}
:host ::ng-deep .p-inputgroup .filter-loading-indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  min-width: 2rem;
  height: 100%;
  color: var(--text-color-secondary, #6b7280);
  font-size: 0.875rem;
  line-height: 1;
  padding: 0 0.25rem;
}
:host ::ng-deep .p-inputgroup .filter-loading-indicator .pi {
  animation-duration: 0.8s;
}
/*# sourceMappingURL=entity-dropdown-multiselect-picker.component-E5VJ7FAH.css.map */
